<template>
  <div class="modal-card card">
    <div class="card-header">
      <h4 class="card-header-title text-truncate" style="max-width: 400px;">{{ title }}</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="card-body">
      <div class="text-center mb-4">
        <div class="mb-3">
          <label class="form-label fw-bold">Audience Name <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            v-model="audienceName"
            placeholder="Enter name for new audience"
          />
        </div>
      </div>

      <div v-if="selectedAudiences.length > 0">
        <table class="table table-bordered text-center" aria-label="List of Audiences">
          <thead class="table-light">
            <tr>
              <th scope="col" colspan="2">{{ tableHeader }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="audience in selectedAudiences" :key="audience.id">
              <td style="width: 15%;">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="checkboxSelectedMap[audience.id]"
                  @change="handleAudienceSelection($event, audience)"
                >
              </td>
              <td>{{ audience.audience_name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="text-center text-muted py-4">
        There are no common audiences available
      </div>

      <div v-if="error" class="alert alert-danger mt-3">
        {{ error }}
      </div>
    </div>
    <div class="card-footer">
      <button
        class="btn btn-primary"
        @click="saveAudience"
        :disabled="disableSaveButton || saving"
      >
        <span v-if="saving" class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
        Save
      </button>
      <button class="btn btn-secondary ms-2" data-bs-dismiss="modal">
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ListSelectedAudience',
  props: {
    modalData: Object,
  },
  data() {
    return {
      audienceName: '',
      checkboxSelectedMap: {},
      listAudiences: [],
      saving: false,
      error: null,
    }
  },
  computed: {
    type() {
      return this.modalData?.type || 'Union'
    },
    selectedAudiences() {
      return this.modalData?.selectedAudiences || []
    },
    audience() {
      return this.modalData?.audience
    },
    checked() {
      return this.modalData?.checked !== false
    },
    title() {
      if (this.type === 'Union') {
        return 'Union Audience'
      } else if (this.type === 'Intersect') {
        return 'Intersect Audience'
      } else if (this.type === 'Subtract') {
        return `Subtract from ${this.audience?.audience_name || 'Audience'}`
      }
      return 'Aggregate Audience'
    },
    tableHeader() {
      if (this.type === 'Union' || this.type === 'Intersect') {
        return 'Confirm Audiences Selected'
      }
      return 'Please select audience(s) to subtract'
    },
    disableSaveButton() {
      if (!this.audienceName.trim()) {
        return true
      }
      if (this.type === 'Union' || this.type === 'Intersect') {
        return this.listAudiences.length < 2
      }
      if (this.type === 'Subtract') {
        return this.listAudiences.length < 1
      }
      return false
    },
  },
  methods: {
    ...mapActions({
      saveAggregateAudience: 'audience/saveAggregateAudience',
      subtractAudience: 'audience/subtractAudience',
      fetchAudiences: 'audience/fetchAudiences',
      hideModal: 'hideModal',
      addToast: 'addToast',
    }),
    handleAudienceSelection(event, audience) {
      if (event.target.checked) {
        this.checkboxSelectedMap[audience.id] = true
        this.listAudiences.push(audience)
      } else {
        this.checkboxSelectedMap[audience.id] = false
        this.listAudiences = this.listAudiences.filter(a => a.id !== audience.id)
      }
    },
    async saveAudience() {
      this.saving = true
      this.error = null

      try {
        if (this.type === 'Union' || this.type === 'Intersect') {
          await this.saveAggregateAudience({
            audiences: this.listAudiences,
            audienceName: this.audienceName.trim(),
            type: this.type,
          })
        } else if (this.type === 'Subtract') {
          await this.subtractAudience({
            targetAudience: this.audience,
            subtractAudiences: this.listAudiences,
            audienceName: this.audienceName.trim(),
          })
        }

        this.addToast({ type: 'success', message: `${this.type} audience created successfully` })
        await this.fetchAudiences()
        this.hideModal()
      } catch (error) {
        this.error = error.response?.data?.message || error.message || `Failed to create ${this.type.toLowerCase()} audience`
      } finally {
        this.saving = false
      }
    },
  },
  mounted() {
    // Initialize checkbox states and list based on type
    if (this.type === 'Union' || this.type === 'Intersect') {
      this.listAudiences = this.selectedAudiences.slice()
    } else if (this.type === 'Subtract') {
      this.listAudiences = []
    }

    this.selectedAudiences.forEach(audience => {
      this.checkboxSelectedMap[audience.id] = this.checked
    })
  },
}
</script>
